import {BehaviorSubject, combineLatest} from 'rxjs';
import {map, shareReplay, startWith} from 'rxjs/operators';

export const docActive$ = new BehaviorSubject<boolean>(true);

document.addEventListener('visibilitychange', () => {
  docActive$.next(!document.hidden);
});

export const ipPromptHeight$ = new BehaviorSubject<number>(0);
export const announcementHeight$ = new BehaviorSubject<number>(0);

export const totalTopHeight$ = combineLatest([ipPromptHeight$, announcementHeight$]).pipe(
  map(([ipPromptHeight, announcementHeight]) => ipPromptHeight + announcementHeight),
  startWith(0),
  shareReplay(1)
);
